import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../stores/store';
import { FlexContainer } from '../../../common/flex-container/flex-container.styles';
import { ParcelContentTypeGroup } from './parcel-details-dimensions.styles';
import RadioButton from '../../../common/radio/radio-button.component';
import Tip from '../../../common/toasts/tip.component';
import { ShipmentTypeToTranslationMap } from './helpers';
import useShipmentType from './use-shipment-type';

const ShipmentTypeSelector = () => {
  const {
    parcelCreationStore: {
      deliveryLimitations,
      isNextStepButtonLoading,
      prefillInProgress,
      setShipmentType,
      shipmentType,
      countryDeparture,
      countryDestination,
    },
  } = useStore();

  const { t } = useTranslation();

  const { shipmentTypes, showShipmentTypeRadioBlock } = useShipmentType();

  const handleParcelContentTypeChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setShipmentType(event.target.value);
    },
    [setShipmentType]
  );

  const disabled =
    !countryDeparture ||
    !countryDestination ||
    isNextStepButtonLoading ||
    prefillInProgress;

  if (!showShipmentTypeRadioBlock) return null;

  return (
    <FlexContainer
      $direction='column'
      $align='start'
      $gap='1.6rem'>
      <ParcelContentTypeGroup>
        {shipmentTypes.map((x) => (
          <RadioButton
            key={x}
            name='parcel-content-type'
            value={x}
            checked={shipmentType === x}
            onChange={handleParcelContentTypeChange}
            disabled={disabled}
            text={t(ShipmentTypeToTranslationMap[x].transKey)}
            icon={ShipmentTypeToTranslationMap[x].icon}
          />
        ))}
      </ParcelContentTypeGroup>
      {deliveryLimitations?.limitWarning && (
        <Tip
          appearance='warning'
          description={deliveryLimitations?.limitWarning}
        />
      )}
    </FlexContainer>
  );
};

export default observer(ShipmentTypeSelector);
